import { CabecalhoDePagina } from '../componentes/Superficie.tsx';
import { TrilhaDeAuditoria } from '../componentes/TrilhaDeAuditoria.tsx';

/**
 * A tela inteira da trilha.
 *
 * A operação chega pelo acordeão de Configurações; esta rota continua
 * existindo para quem tem o endereço, e é o mesmo conteúdo com cabeçalho.
 */
export function PaginaAuditoria(): React.JSX.Element {
  return (
    <section>
      <CabecalhoDePagina area="Administração" titulo="Auditoria" />
      <TrilhaDeAuditoria />
    </section>
  );
}
